var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolocalendaricon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36.327,
    height: 34.891,
    viewBox: "0 0 36.327 34.891",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_8202",
    x: 0,
    y: 2.193,
    width: 32.516,
    height: 26.788,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1892",
    x: 8.18,
    y: 8.812,
    width: 22.151,
    height: 21.142,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1893",
    x: 14.176,
    y: 8.812,
    width: 22.151,
    height: 21.142,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1896",
    x: 8.18,
    y: 13.749,
    width: 22.151,
    height: 21.142,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10267",
    "data-name": "Group 10267",
    transform: "translate(-55.525 -40.968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8357",
    "data-name": "Group 8357",
    transform: "translate(57.025 40.968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8356",
    "data-name": "Group 8356"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1.5, 0)",
    filter: "url(#Path_8202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8202-2",
    "data-name": "Path 8202",
    d: "M84.235,53.429H81.929v1.8a1.845,1.845,0,0,1-3.69,0v-1.8H65.326v1.8a1.845,1.845,0,0,1-3.689,0v-1.8H59.331a2.278,2.278,0,0,0-2.306,2.244v19.3a2.278,2.278,0,0,0,2.306,2.244h24.9a2.278,2.278,0,0,0,2.306-2.244v-19.3A2.278,2.278,0,0,0,84.235,53.429ZM84.7,74.973a.461.461,0,0,1-.461.449h-24.9a.461.461,0,0,1-.461-.449V58.815H84.7Z",
    transform: "translate(-55.52 -50.74)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1887",
    "data-name": "Rectangle 1887",
    width: 4.151,
    height: 3.142,
    rx: 1.5,
    transform: "translate(9.685 9.874)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1888",
    "data-name": "Rectangle 1888",
    width: 4.151,
    height: 3.142,
    rx: 1.5,
    transform: "translate(15.68 9.874)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1889",
    "data-name": "Rectangle 1889",
    width: 4.151,
    height: 3.142,
    rx: 1.5,
    transform: "translate(21.676 9.874)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1890",
    "data-name": "Rectangle 1890",
    width: 4.151,
    height: 3.142,
    rx: 1.5,
    transform: "translate(9.685 14.812)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1891",
    "data-name": "Rectangle 1891",
    width: 4.151,
    height: 3.142,
    rx: 1.5,
    transform: "translate(3.69 14.812)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1.5, 0)",
    filter: "url(#Rectangle_1892)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1892-2",
    "data-name": "Rectangle 1892",
    width: 4.151,
    height: 3.142,
    rx: 1.5,
    transform: "translate(17.18 14.81)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1.5, 0)",
    filter: "url(#Rectangle_1893)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1893-2",
    "data-name": "Rectangle 1893",
    width: 4.151,
    height: 3.142,
    rx: 1.5,
    transform: "translate(23.18 14.81)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1894",
    "data-name": "Rectangle 1894",
    width: 4.151,
    height: 3.142,
    rx: 1.5,
    transform: "translate(9.685 19.749)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1895",
    "data-name": "Rectangle 1895",
    width: 4.151,
    height: 3.142,
    rx: 1.5,
    transform: "translate(3.69 19.749)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1.5, 0)",
    filter: "url(#Rectangle_1896)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1896-2",
    "data-name": "Rectangle 1896",
    width: 4.151,
    height: 3.142,
    rx: 1.5,
    transform: "translate(17.18 19.75)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8203",
    "data-name": "Path 8203",
    d: "M82.871,46.354a.91.91,0,0,0,.922-.9V41.865a.923.923,0,0,0-1.845,0v3.591A.91.91,0,0,0,82.871,46.354Z",
    transform: "translate(-76.415 -40.968)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8204",
    "data-name": "Path 8204",
    d: "M157.64,46.354a.91.91,0,0,0,.922-.9V41.865a.923.923,0,0,0-1.845,0v3.591A.91.91,0,0,0,157.64,46.354Z",
    transform: "translate(-134.581 -40.968)",
    fill: "#3c3c3b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolocalendaricon);
export default __webpack_public_path__ + "static/media/solo calendar icon.6a8a16aa9d52a30a0aee3ca0d4a88a39.svg";
export { ForwardRef as ReactComponent };